export default {
  status1: ['待分配', '待提交', '待验收', 'dai', '通过'],
  status2: ['待验收', 'dai', '通过'],
  // 清单状态
  getStatus(role, status) {
    if (role === 0) {
      return this.status2[status - 3];
    } else {
      return this.status1[status - 1];
    }
  },
  getOperation(role, status) {
    const operations = [];
    if (role === 0) {
      if ([5].includes(status)) {
        operations.push('查看');
      }
      if ([3].includes(status)) {
        operations.push('验收');
      }
    } else {
      if ([2, 3, 5].includes(status)) {
        operations.push('查看');
      }
    }
    return operations;
  },
  // status: ['待提交', '审核中', '驳回', '通过'],

  // getReportStatus(role, status) {
  //   if (role === 0) {
  //     return this.status[status - 1];
  //   } else {
  //     return this.status[status - 1];
  //   }
  // },
  // getOperation(role, status) {
  //   const operations = [];
  //   if (role === 0) {
  //     if ([3].includes(status)) {
  //       operations.push('查看');
  //     }
  //     if ([2].includes(status)) {
  //       operations.push('审核');
  //     }
  //     if ([4].includes(status)) {
  //       operations.push('预览');
  //       operations.push('下载');
  //       operations.push('查看');
  //     }
  //   } else {
  //     if ([1, 2].includes(status)) {
  //       operations.push('查看');
  //     }
  //     if ([3].includes(status)) {
  //       operations.push('编辑');
  //     }
  //     if ([4].includes(status)) {
  //       operations.push('预览');
  //       operations.push('下载');
  //       operations.push('查看');
  //     }
  //   }
  //   return operations;
  // },
  // 报告操作
  getReportOperation(role, status, listStatus) {
    const operations = [];
    if (role === 0) {
      operations.push('查看');

    } else {
      if ([1].includes(status)) {
        operations.push('通过');
        operations.push('驳回');
        operations.push('去重');
      }
      // if ([0].includes(status)) {
      //   operations.push('编辑');
      // }
      if ([0, 1, 2, 3].includes(status)) {
        operations.push('查看');
      }
      // if ([3].includes(status)) {
      //   operations.push('编辑');
      //   operations.push('无效');
      // }
    }
    return operations;
  },
};
